import {
    GLOBAL_CLEAR_LAST_BREADCRUMB,
    GLOBAL_SET_LAST_BREADCRUMB,
    GLOBAL_SET_TITLE,
    GLOBAL_SET_UPGRADE_REQUIRED, SET_OWNER_CONFIG,
    SET_PORTAL_TYPE, SET_STRIPE_ENABLED,
} from "../actionTypes";
import api from "../../api/api";

export function setGlobalTitle(title) {
    return {
        type: GLOBAL_SET_TITLE,
        title
    }
}

export function setGlobalLastBreadcrumb(breadcrumb) {
    return {
        type: GLOBAL_SET_LAST_BREADCRUMB,
        breadcrumb
    }
}

export function clearGlobalLastBreadcrumb() {
    return {
        type: GLOBAL_CLEAR_LAST_BREADCRUMB
    }
}

export function setUpgradeRequired() {
    return {
        type: GLOBAL_SET_UPGRADE_REQUIRED
    }
}

export function portalTypeGlobalState(payload) {
    return (dispatch) => {
        api.get(`config?url=${payload}`, {data: null})
            .then(response => {
                let backload = {
                    type: "guest",
                    ownerConfig: {
                        showAccommodationTotals: true,
                        showExtrasTotals: true,
                        showGuestNames: true,
                        showExtras: true
                    }
                };

                const { data } = response;
                if (data && data.type !== null && data.type !== undefined) {
                    backload.type = data.type;
                }
                if (data && data.ownerConfig !== null && data.ownerConfig !== undefined) {
                    backload.ownerConfig = data.ownerConfig;
                }
                dispatch(setPortalType(backload));
                dispatch(setOwnerConfig(backload));
                if (payload.includes("demo") || payload.includes("localhost") || payload.includes("collective") || payload.includes("staging") || payload.includes("domus")) {
                    dispatch(setStripeEnabled(true));
                }
            });
    };
}

export function setPortalType(payload) {
    return {
        type: SET_PORTAL_TYPE,
        payload
    }
}

export function setOwnerConfig(payload) {
    return {
        type: SET_OWNER_CONFIG,
        payload
    }
}


export function setStripeEnabled(payload) {
    return {
        type: SET_STRIPE_ENABLED,
        payload
    }
}
